import React, {Component} from 'react';
import {Link}             from 'react-router-dom';
import Translator         from "../../components/Translator";
import Header             from "../Header/Header";

import {v4 as generateUUID} from "uuid";

import checkInImg from '../../styles/images/checknewscreen-in.jpg';
import mucOpCheckInImg from '../../styles/images/checkinmunchen.svg';
import checkOutImg from '../../styles/images/checkoutLabel.jpg';
import mucOpCheckoutImg from '../../styles/images/checkoutmunchen.svg';
import neueKeycardImg from '../../styles/images/Stayery-SCT-Lost-Key-Card.jpg';
import mocNeueCardImg from '../../styles/images/neuecardmunchen.svg';
import {AppContext, DEFAULT_LANG} from "../../contexts/AppContext";
import {getLocationId, getLocationTranslationKey} from "../../themes";

class Main extends Component
{
    componentDidMount()
    {
        this.context.changeLanguage(DEFAULT_LANG);
    }

    gotoCheckout()
    {
        const uuid = generateUUID();

        try {
            this.props.apiClient.postAnalyticsData(uuid, 'go to /main/checkout/');
        } catch (e) {
            console.error(e);
        }

        this.props.history.push({pathname: '/main/checkout/'}, {uuid: uuid})
    }
    render()
    {
        const isMucOp = getLocationId() === 'MUC_OP';
        return (<div className="page-main">
            <div className="page-inner-wrapper">
                <Header headerTitle={getLocationTranslationKey("pageTitles.mainPage")}/>
                <div className="content-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="bodytext-app _main-page-text">
                                    <Translator content={getLocationTranslationKey("main.description")}/>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="flipkachel-wrapper">
                                    <Link style={{textDecoration: 'none'}} to={'/main/checkin/login'}>
                                        <div className="stayery-flipkachel _check-in">
                                            <div className="flipkachel-inner-wrap">
                                                <div className="__header">
                                                    <Translator
                                                        content={"main.checkinLabel"}
                                                    />
                                                </div>
                                                <div className="__image">
                                                    <img src={isMucOp? mucOpCheckInImg : checkInImg} alt="Check-in"/>
                                                </div>
                                                {isMucOp ? (
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="__left _centered">
                                                                <Translator content={"main.shop"}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <div className="__left">
                                                                <Translator content={"main.shop"}/>
                                                            </div>
                                                        </div>
                                                        <div className="col-6">
                                                            <div className="__right">
                                                                <i className="icon icon-stayery-arrow-r"/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </Link>

                                    <Link style={{textDecoration: 'none'}} to={"/main/checkout"}>
                                        <div className="stayery-flipkachel _check-out">
                                            <div className="flipkachel-inner-wrap">
                                                <div className="__header">
                                                    <Translator
                                                        content={"main.checkoutLabel"}
                                                    />
                                                </div>
                                                <div className="__image">
                                                    <img src={isMucOp ? mucOpCheckoutImg :checkOutImg} alt="checkout"/>
                                                </div>
                                                {isMucOp ? (
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="__left _centered">
                                                                <Translator content={"main.checkoutbtn"}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <div className="__left">
                                                                <Translator content={"main.checkoutbtn"}/>
                                                            </div>
                                                        </div>
                                                        <div className="col-6">
                                                            <div className="__right">
                                                                <i className="icon icon-stayery-arrow-r"/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </Link>

                                    <Link style={{textDecoration: 'none'}} to={'/main/lostcard'}>
                                        <div className="stayery-flipkachel _keycard">
                                            <div className="flipkachel-inner-wrap">
                                                <div className="__header">
                                                    <Translator
                                                        content={"main.neuekeycardLabel"}
                                                    />
                                                </div>
                                                <div className="__image">
                                                    <img src={isMucOp ? mocNeueCardImg : neueKeycardImg} alt="Check-out"/>
                                                </div>
                                                {isMucOp ? (
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="__left _centered">
                                                                <Translator content={"main.lostcard"}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <div className="__left">
                                                                <Translator content={"main.lostcard"}/>
                                                            </div>
                                                        </div>
                                                        <div className="col-6">
                                                            <div className="__right">
                                                                <i className="icon icon-stayery-arrow-r"/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>);
    }
}

Main.contextType = AppContext;

export default Main;
